var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-section"},[_c('OrderList',{attrs:{"input":_vm.input,"params":_vm.params,"title":"Order History"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }